import type { CaseBlock } from "@/mocks/cases";

export default function ArticleBody({ blocks }: { blocks: CaseBlock[] }) {
  return (
    <div className="prose-case">
      {blocks.map((block, index) => {
        const key = `${block.type}-${index}`;

        if (block.type === "h2") {
          return (
            <h2
              key={key}
              id={`heading-${index}`}
              className="scroll-mt-[100px] mt-10 mb-4 font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug border-l-4 border-accent-500 pl-4"
            >
              {block.text}
            </h2>
          );
        }

        if (block.type === "h3") {
          return (
            <h3
              key={key}
              className="mt-8 mb-3 font-heading text-base md:text-lg font-semibold text-foreground-900"
            >
              {block.text}
            </h3>
          );
        }

        if (block.type === "quote") {
          return (
            <blockquote
              key={key}
              className="my-7 px-5 py-4 rounded-md bg-accent-50 border-l-4 border-accent-500"
            >
              <p className="font-heading text-base md:text-lg font-semibold text-accent-900 leading-relaxed">
                {block.text}
              </p>
            </blockquote>
          );
        }

        if (block.type === "list") {
          return (
            <ul key={key} className="my-5 space-y-2.5">
              {(block.items || []).map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-secondary-500 shrink-0"></span>
                  <span className="leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          );
        }

        return (
          <p key={key} className="text-sm md:text-base">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}